<template>
    <section>
        <div class="container">
            <form class="form-group row d-flex justify-content-md-center">
                <div class="col-md-6">
                    <v-select  v-model="id" :options=getOptions() :reduce="poke => poke.code"></v-select>
                </div>
                    <div class="col-md-1 form-check">
                        <label for="pvp-chbox">
                            <input id="pvp-chbox" type="checkbox" for="pvp-chbox" class="form-check-input" v-model="pvp"/>PvP
                        </label>
                    </div>
                <div class="col-xs-12 col-md-2 col-lg-1">
                    <button type="button" class="btn btn-dark btn-block  " v-on:click="onAdd">Add</button>
                </div>
            </form>
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="d-flex flex-wrap justify-content-sm-around justify-content-center">
                        <PokemonBattleInfo  v-bind:pvp="pvp" v-if="pokemon1.id!==undefined && pokemon2.id!==undefined" :pokemon1="pokemon1" :pokemon2="pokemon2" updatex=""/>
                        <div class="w-100"></div>
                        <PokemonGoStatCalc v-for="poke in children"
                                           :pokemonId="poke.id"
                                           :uuid="poke.uuid"
                                           :onDelete="onDelete"
                                           :onEdit="onEdit"
                                           :poke="poke"
                                           :pvp="pvp"
                                           :addBattler="addBattler"
                                           :update-battler="updateBattler"
                                           v-bind:key="poke.uuid"/>
                    </div>
                </div>
            </div>

        </div>
    </section>

</template>

<script>
    import PokemonGoStatCalc from "./PokemonGoStatCalc";
    import {shortId} from '../../helpers/UUIDGen'
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';
    import {pokemon_name_id} from "../../helpers/pokemon_data";
    import PokemonBattleInfo from "./PokemonBattleInfo";
    import {fromBase64, lzw_decode, lzw_encode, toBase64} from "../../helpers/utils";// eslint-disable-line
    /*eslint no-unused-vars: "error"*/
    export default {
        name: "PokemonAdder",
        components: {PokemonBattleInfo, PokemonGoStatCalc, vSelect},
        data: function () {
            let initChildren = this.$route.query.pokemon;
            if(initChildren !== undefined){
                initChildren = JSON.parse(initChildren);
            }else{
                initChildren = []
            }
            return {
                id: null,
                children: initChildren,
                query: this.$route.query,
                pokemon1:{},
                pokemon2:{},
                pvp:true,
                updatex:0,
            }
        },
        methods: {
            onAdd: function () {
                this.children.push({id: this.id, uuid: shortId()});
                this.pushToRoute();

            },
            onDelete: function (childUuid) {
                this.children = this.children.filter(function (item) {
                    return item.uuid != childUuid;
                });
                this.pushToRoute();
            },
            addBattler: function(position,uuid){
                let poke = this.children.find(function (item) {
                    return item.uuid == uuid;
                });
                this['pokemon'+position] = poke;

            },
            updateBattler:function(){
              this.updatex+=1;
            },
            getOptions: function () {
                return pokemon_name_id;
            },
            onEdit:function (uuid,data) {
                let child = this.children.find((ch)=>ch.uuid==uuid);
                Object.assign(child, data);
                this.pushToRoute();
            },
            pushToRoute:function () {
                let encodedData = (JSON.stringify(this.children));
                this.$router.replace({query:{pokemon:encodedData}});
            }
        },
        watch: {
            children() {
                this.pushToRoute()
            },
        },
    }
</script>

<style scoped>

</style>